<app-banner [heading]="'OUR INFRA - MATH LAB'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->
    <section id="features" class="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-6 " >
            <img src="assets/img/infra/mathlab/math-lab-1.jpg" class="img-fluid" alt="">
          </div>
          <div class="col-lg-6  pt-5 pt-lg-0" >
              
              <p> <br>Math is fun at <b>Tagore Global School, Kurukshetra.</b> It offers Multiple Teaching and 
			  Learning aids as well as a complete theme based ambience which helps students to 
			  visualize and feel mathematics. <br><br>Based on the three pillars of ‘Imagination, Investigation
			  and Interaction’, it provides an opportunity to students to understand, internalize,
			  discover and verify the basic mathematical and geometrical concepts through concrete 
			  objects and situations.
			  
			  </p>
              
            </div>
		  
		</div>
      </div>
	</section><!-- End About Section -->


	
	
    
    
  </main>